/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateUpdateOrganizationDto,
    CreateUpdateOrganizationDtoFromJSON,
    CreateUpdateOrganizationDtoFromJSONTyped,
    CreateUpdateOrganizationDtoToJSON,
    CreateUpdatePartyToProceedingDto,
    CreateUpdatePartyToProceedingDtoFromJSON,
    CreateUpdatePartyToProceedingDtoFromJSONTyped,
    CreateUpdatePartyToProceedingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateUpdatePartyWithOrganizationDto
 */
export interface CreateUpdatePartyWithOrganizationDto {
    /**
     * 
     * @type {CreateUpdateOrganizationDto}
     * @memberof CreateUpdatePartyWithOrganizationDto
     */
    organization: CreateUpdateOrganizationDto;
    /**
     * 
     * @type {CreateUpdatePartyToProceedingDto}
     * @memberof CreateUpdatePartyWithOrganizationDto
     */
    party: CreateUpdatePartyToProceedingDto;
}

export function CreateUpdatePartyWithOrganizationDtoFromJSON(json: any): CreateUpdatePartyWithOrganizationDto {
    return CreateUpdatePartyWithOrganizationDtoFromJSONTyped(json, false);
}

export function CreateUpdatePartyWithOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePartyWithOrganizationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization': CreateUpdateOrganizationDtoFromJSON(json['organization']),
        'party': CreateUpdatePartyToProceedingDtoFromJSON(json['party']),
    };
}

export function CreateUpdatePartyWithOrganizationDtoToJSON(value?: CreateUpdatePartyWithOrganizationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization': CreateUpdateOrganizationDtoToJSON(value.organization),
        'party': CreateUpdatePartyToProceedingDtoToJSON(value.party),
    };
}


